<script setup lang="ts">
import {ref} from "vue";

withDefaults(defineProps<{
    author: string,
    created_at: string,
    note: string,
}>(), {
    author: "Carl Johnson",
    created_at: "2025-10-24T12:27:06.000000Z",
    note: 'meh'
})

const is_open = ref(false)
const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  const day = date.getDate();
  const month = date.toLocaleString('en-GB', { month: 'long' });
  const year = date.getFullYear();

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day} ${month} ${year}  •  ${hours}:${minutes}`;
};
</script>

<template>
<div class="call-note-accordion" @click="is_open = !is_open">
    <div class="call-note-accordion-header">
        <div class="call-note-accordion-header-content">
            <ah-icon name="paper-file" :size="24" />
            <div class="call-note-accordion-header-content-detail">
                <p class="call-note-accordion-header-content-detail-author">{{author}}</p>
                <p class="call-note-accordion-header-content-detail-date">{{formatDate(created_at)}}</p>
            </div>

        </div>
        <ah-icon :name="is_open ? 'chevron-down-up' : 'chevron-up-down'" :size="24" />
    </div>

    <p class="call-note-accordion-content" v-if="is_open" v-html="note"></p>
</div>
</template>

<style scoped lang="scss">
.call-note-accordion {
    padding: 2rem;
    border-radius: 2.4rem;
    background: var(--color-mist);
    cursor: pointer;

    &-header {
        display: flex;
        gap: 2rem;
        justify-content: space-between;
        align-items: center;

        &-content {
            display: flex;
            gap: 2rem;
            align-items: center;
            &-detail {
                display: flex;
                flex-direction: column;
                gap: 0.8rem;

                &-author {
                    @include font(1.4, 1.4, black);
                }
                &-date {
                    @include font(1.4, 1.4, book);
                }
            }
        }
        .icon {
            fill: var(--color-hazy);
            &:first-child {
                fill: var(--color-tiffany-dark);
            }
        }
    }

    &-content {
        @include font(1.4, 1.8, book);
        margin-top: 2rem;
    }

    @include dark() {
        background: var(--color-darth-sidious);
    }
}
</style>
